module.exports = __webpack_public_path__ + "img/login.6537dce9.png";